module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded",
    staticStyle: {
      "text-align": "left"
    }
  }, [(!_vm.hidePanel) ? _c('edit-pane', {
    ref: "ep",
    attrs: {
      "prefix": "Structure: ",
      "title": (_vm.struct.name ? _vm.struct.name : (_vm.struct.category + ' ' + _vm.struct.type)),
      "editable": _vm.isTowerSupplierCo() || _vm.isManager('project|maintenance'),
      "deletable": (_vm.isTowerSupplierCo() || _vm.isManager('management')) && ((_vm.struct.site && _vm.struct.site.status !== 'Active' ? true : false)) || !_vm.struct.structure_id,
      "is-edit": _vm.editMode
    },
    on: {
      "save": _vm.onSave,
      "cancel": _vm.onCancel,
      "delete": _vm.deleteStruct,
      "edit": _vm.onEdit,
      "add": _vm.onSave
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.struct,
      "label-position": "left",
      "label-width": "120px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-tabs', {
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [(_vm.isTowerSupplierCo() || _vm.canAccess('project|maintenance|management')) ? _c('el-tab-pane', {
    attrs: {
      "name": "struct"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-pencil-ruler"
  }), _vm._v(" " + _vm._s(_vm.siteId ? 'Structure' : 'Design'))]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "left",
      "label-width": "10em",
      "inline": ""
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "lg": _vm.siteId ? 12 : 24,
      "md": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Structure Details:")])]), _vm._v(" "), (_vm.siteId) ? _c('div', [(_vm.isAdding || _vm.isManager('project|management')) ? _c('select-structure', {
    attrs: {
      "label": "Structure",
      "disabled": _vm.disabled && _vm.canAccess('project|management') && _vm.isTowerCo()
    },
    model: {
      value: (_vm.struct.structure_id),
      callback: function($$v) {
        _vm.$set(_vm.struct, "structure_id", $$v)
      },
      expression: "struct.structure_id"
    }
  }) : _vm._e()], 1) : _c('div', [_c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Type",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.struct.type),
      callback: function($$v) {
        _vm.$set(_vm.struct, "type", $$v)
      },
      expression: "struct.type"
    }
  })], 1), _vm._v(" "), (_vm.struct.subType || !_vm.disabled) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('text-input', {
    attrs: {
      "label": "subType",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.struct.subType),
      callback: function($$v) {
        _vm.$set(_vm.struct, "subType", $$v)
      },
      expression: "struct.subType"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.struct.variant || !_vm.disabled) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Variant",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.struct.variant),
      callback: function($$v) {
        _vm.$set(_vm.struct, "variant", $$v)
      },
      expression: "struct.variant"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.siteId) ? _c('text-input', {
    attrs: {
      "label": "Default Heights",
      "suffix": "m.",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.struct.defaultHeights),
      callback: function($$v) {
        _vm.$set(_vm.struct, "defaultHeights", $$v)
      },
      expression: "struct.defaultHeights"
    }
  }) : _vm._e(), _vm._v(" "), _c('integer-input', {
    attrs: {
      "label": "Height",
      "suffix": "m.",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.struct.height),
      callback: function($$v) {
        _vm.$set(_vm.struct, "height", $$v)
      },
      expression: "struct.height"
    }
  }), _vm._v(" "), (!_vm.disabled && _vm.siteId && _vm.struct.design && _vm.struct.design.defaultHeights) ? _c('el-form-item', {
    attrs: {
      "label": "Default Heights"
    }
  }, [_c('i', [_c('b', [_vm._v(_vm._s(_vm.struct.design.defaultHeights))])])]) : _vm._e(), _vm._v(" "), _c('float-input', {
    attrs: {
      "label": "Max. Weight",
      "icon": "fa fa-weight",
      "suffix": "kg.",
      "decimals": 2,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.struct.weight),
      callback: function($$v) {
        _vm.$set(_vm.struct, "weight", $$v)
      },
      expression: "struct.weight"
    }
  })], 1), _vm._v(" "), _c('br')], 1), _vm._v(" "), ((_vm.struct.depth || _vm.struct.width) || !_vm.disabled) ? _c('el-col', {
    attrs: {
      "lg": _vm.siteId ? 12 : 24,
      "md": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Site Area:")])]), _vm._v(" "), _c('integer-input', {
    attrs: {
      "label": "Depth",
      "suffix": "m.",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.struct.depth),
      callback: function($$v) {
        _vm.$set(_vm.struct, "depth", $$v)
      },
      expression: "struct.depth"
    }
  }), _vm._v(" "), _c('integer-input', {
    attrs: {
      "label": "Width",
      "suffix": "m.",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.struct.width),
      callback: function($$v) {
        _vm.$set(_vm.struct, "width", $$v)
      },
      expression: "struct.width"
    }
  })], 1), _vm._v(" "), _c('br')], 1) : _vm._e()], 1), _vm._v(" "), ((_vm.isTowerSupplierCo() || (_vm.isTowerCo() && _vm.canAccess('project|maintenance')))) ? _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [((_vm.struct.sharers || _vm.struct.levels || _vm.struct.power || _vm.struct.life) || !_vm.disabled) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Structure Design:")])]), _vm._v(" "), _c('integer-input', {
    attrs: {
      "label": "Max. Sharers",
      "icon": "fa fa-users",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.struct.sharers),
      callback: function($$v) {
        _vm.$set(_vm.struct, "sharers", $$v)
      },
      expression: "struct.sharers"
    }
  }), _vm._v(" "), _c('integer-input', {
    attrs: {
      "label": "Max. Levels",
      "icon": "fa fa-layer-group",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.struct.levels),
      callback: function($$v) {
        _vm.$set(_vm.struct, "levels", $$v)
      },
      expression: "struct.levels"
    }
  }), _vm._v(" "), _c('float-input', {
    attrs: {
      "label": "Power",
      "icon": "fa fa-plug",
      "suffix": "kwH",
      "decimals": 2,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.struct.power),
      callback: function($$v) {
        _vm.$set(_vm.struct, "power", $$v)
      },
      expression: "struct.power"
    }
  }), _vm._v(" "), _c('integer-input', {
    attrs: {
      "label": "Design Life",
      "icon": "fa fa-calendar-alt",
      "suffix": "years",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.struct.life),
      callback: function($$v) {
        _vm.$set(_vm.struct, "life", $$v)
      },
      expression: "struct.life"
    }
  })], 1), _vm._v(" "), _c('br')], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_c('i', {
    staticClass: "fa fa-paperclip"
  }), _vm._v(" Attachments")]), _vm._v(" "), (_vm.siteId) ? _c('files-panel', {
    attrs: {
      "id": _vm.siteId,
      "type": "site",
      "process": "struct",
      "process-id": _vm.struct.id,
      "max-files": 5,
      "read-only": _vm.readOnly
    }
  }) : _c('files-panel', {
    attrs: {
      "id": _vm.struct.id,
      "type": "struct",
      "read-only": _vm.readOnly
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "struct-supplier"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-tower-cell"
  }), _vm._v(" Supplier")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [(this.isTowerCo() && (_vm.isAdding || !_vm.struct.supplier_id || _vm.isSuper())) ? _c('select-tower-supplier', {
    attrs: {
      "disabled": _vm.disabled && _vm.canAccess('project|maintenance|finance')
    },
    on: {
      "change": _vm.supplierUpdated
    },
    model: {
      value: (_vm.struct.supplier_id),
      callback: function($$v) {
        _vm.$set(_vm.struct, "supplier_id", $$v)
      },
      expression: "struct.supplier_id"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.supplier) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.supplier.name) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 1
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.supplier.name))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.supplier.address) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 1
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.supplier.address))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.supplier.postCode) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 1
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Post Code"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.supplier.postCode))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.supplier.phone) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 1
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phone"
    }
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.supplier.phone
    }
  }, [_vm._v(_vm._s(_vm.supplier.phone))])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.supplier.email) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 1
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "E-mail"
    }
  }, [(_vm.siteId && _vm.site) ? _c('div', [_c('strong', [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.supplier.email + '?subject=RE: Tower Site ' + _vm.site.siteName + ' (' + _vm.site.siteId + ')'
    }
  }, [_vm._v(_vm._s(_vm.supplier.email))])])]) : _c('div', [_c('strong', [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.supplier.email + '?subject=RE: ' + _vm.struct.name + ' for ' + _vm.clientName
    }
  }, [_vm._v(_vm._s(_vm.supplier.email))])])])])], 1)], 1) : _vm._e()], 1)], 1) : _c('el-row')], 1), _vm._v(" "), (_vm.canAccess('project|maintenance|finance')) ? _c('el-tab-pane', {
    attrs: {
      "name": "struct-remarks"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-comment-alt"
  }), _vm._v(" Remarks")]), _vm._v(" "), _c('h4', [_vm._v("Remarks")]), _vm._v(" "), _c('html-input', {
    attrs: {
      "label": "",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.struct.remarks),
      callback: function($$v) {
        _vm.$set(_vm.struct, "remarks", $$v)
      },
      expression: "struct.remarks"
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.struct.updated_at) ? _c('div', [_c('hr'), _vm._v(" "), (_vm.isManager('project|management')) ? _c('span', [_c('el-button', {
    attrs: {
      "type": "danger",
      "circle": "",
      "size": "small"
    },
    on: {
      "click": _vm.deleteStruct
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("Last update: "), _c('b', [_vm._v(_vm._s(_vm.formatFriendlyDate(_vm.struct.updated_at)))]), (_vm.struct.updated_by) ? _c('span', [_vm._v(" by " + _vm._s(_vm.struct.updated_by))]) : _vm._e()])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9cc03daa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/details/StructDetails.vue
// module id = 1601
// module chunks = 0